import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { ISendMail } from '../typings'
import { sendMail } from '../api'

export const useSendMail = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toSend, setToSend] = useState<ISendMail>()

  const execute = useCallback(
    (model: ISendMail) => {
      if (status != 'pending') {
        setToSend(model)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toSend) {
        try {
          setStatus('pending')
          const result = await dispatch(sendMail(toSend))

          if (mounted) {
            if (sendMail.fulfilled.match(result)) {
              setStatus('success')
              toast.success('Welcome email sent')
            } else {
              setStatus('fail')
              toast.error('Unable to send email')
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToSend(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toSend])

  return { status, execute }
}
